<template>
  <el-upload
    class="upload-demo"
    :limit="1"
    :action="url"
    :on-change="handleChange"
    :on-success="success"
    :on-preview="previewFun"
    :on-remove="removeFun"
    :file-list="list">
    <el-button size="mini" type="success">点击上传</el-button>
<!--    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
  </el-upload>
</template>

<script>
export default {
  name: "UploadFileOa",
  props:{
    list:Array,
  },
  data(){
    return {
      url:"",
      url1:""
    }
  },
  mounted() {
    this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
    this.url1 = this.$myhttp.defaults.baseURL;
  },
  methods:{
    handleChange(file, fileList) {
      // console.log(file, fileList)
    },
    success(response, file, fileList){
      let list=[]
      var that=this;
      fileList.map(ret=>{
        list.push({
          name:ret.name,
          url:ret.url||(that.url1+'/storage/'+ret.response.replace('\\','/'))
        })
      })
      that.$emit("success",list)
    },
    removeFun(file, fileList){
      this.$emit("success",fileList)
    },
    previewFun(file){
      window.open(file.url);
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(common.scss);
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/UploadFileOa.vue